import './App.css';
import SignIn from './public/SignIn';
import { Route, Routes } from 'react-router-dom';
import Home from './public/Home';
import ForgotPassword from './public/ForgotPassword';
import PublicLayout from './public/PublicLayout';
import PrivateLayout from './private/PrivateLayout';
import Register from './public/Register';
import ContactUs from './public/ContactUs';
import OrderNow from './public/OrderNow';
import OrderNowStep2 from './public/OrderNow-Step2';
import OrderNowStep1 from './public/OrderNow-Step1';
import OrderNowStep3 from './public/OrderNow-Step3';
import OrderNowStep4 from './public/OrderNow-Step4';
import MyDashboard from './private/MyDashboard';
import MyProfile from './private/MyProfile';
import MyContactUs from './private/MyContactUs';
import PartnershipProgramStep1 from './public/PartnershipProgramStep1';
import PartnershipProgramStep2 from './public/PartnershipProgramStep2';
import PartnershipProgramBecomeOurPartner from './public/PartnershipProgramBecomeOurPartner';

function App() {
  return (
      <Routes>
        <Route element={<PublicLayout></PublicLayout>}>
          <Route path="/home" element={<Home></Home>}></Route>
          <Route path="/" element={<Home></Home>}></Route>
          <Route path="/get-started" element={<OrderNow></OrderNow>}></Route>
          <Route path="/order-now-step1" element={<OrderNowStep1></OrderNowStep1>}></Route>
          <Route path="/order-now-step2" element={<OrderNowStep2></OrderNowStep2>}></Route>
          <Route path="/order-now-step3" element={<OrderNowStep3></OrderNowStep3>}></Route>
          <Route path="/order-now-step4" element={<OrderNowStep4></OrderNowStep4>}></Route>
          <Route path="/contact-us" element={<ContactUs></ContactUs>}></Route>
          <Route path="/register" element={<Register></Register>}></Route>
          <Route path="/sign-in" element={<SignIn></SignIn>}></Route>
          <Route path="/forgot-password" element={<ForgotPassword></ForgotPassword>}></Route>
          <Route path="/become-our-partner/:storeID" element={<PartnershipProgramBecomeOurPartner></PartnershipProgramBecomeOurPartner>}></Route>
          <Route path="/become-our-partner" element={<PartnershipProgramBecomeOurPartner></PartnershipProgramBecomeOurPartner>}></Route>
          <Route path="/partnership-program-step1" element={<PartnershipProgramStep1></PartnershipProgramStep1>}></Route>
          <Route path="/partnership-program-step2" element={<PartnershipProgramStep2></PartnershipProgramStep2>}></Route>

        </Route>
        <Route element={<PrivateLayout></PrivateLayout>}>
          <Route path="/my-dashboard" element={<MyDashboard></MyDashboard>}></Route>
          <Route path="/my-profile" element={<MyProfile></MyProfile>}></Route>
          <Route path="/my-contact-us" element={<MyContactUs></MyContactUs>}></Route>
        </Route>
      </Routes>
  );
}

export default App;
